import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'shipWindow'
})
export class ShipWindowPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (value && value.obey_ship_window === 'N' && value.ship_by) {
      return `${moment().format('MM/DD/YY')}-${moment(value.ship_by).format('MM/DD/YY')}`;
    } else  if (value  && value.ship_by && value.effective_date) {
      return `${moment(value.effective_date).format('MM/DD/YY')}-${moment(value.ship_by).format('MM/DD/YY')}`;
    }
    return '';
  }

}
